import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Sofort-Download', 'Kein Abo', 'Lebenslanger Zugriff', '7 Tage Garantie'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-111" data-mp="9lv0eoeuobus">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="4lqiqv27hb2z">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-113" data-mp="4n1j0kwg00pc">
          Löse ein ganzes Jahr Pilates-Unterricht in nur{' '}
          <span className="italic text-brand" data-id="element-114" data-mp="ncq47mahs2ri">5 Minuten</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-115" data-mp="3d1a83izra9cr">
          Schließe dich über 1.200 Trainern an, die aufgehört haben zu improvisieren. Geh in den
          Kurs mit allem, was du zum Erklären, Zeigen und Inspirieren brauchst.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-116" data-mp="39cpbapgo3b09">
          <img src="https://cdn.magicpatterns.com/uploads/vLDzzqDjSFkQUvQxxutxrp/aabf47c4-41f6-41a7-b0a2-889b740b5ddf.webp" alt="Das PILATES BEREIT Paket: die sechs Bände vom Matten-Basics bis zum Profi-Reformer, inklusive visueller Anatomie, fertigen Stundenbildern und den 5 strategischen Boni" className="mx-auto w-full max-w-2xl" data-id="element-117" data-mp="35aasg5d00b8z" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-118" data-mp="2lk8ra9ddd8yb">
          <CtaButton href="#offer" data-id="element-119" data-mp="n9i71lij9uyc" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-120" data-mp="ibgor2sxlznx">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-121" data-mp="1b1fel0eya0tn" data-mpi={index}>
                <span data-id="element-122" data-mp="1ayjilhmnxm7u">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-123" data-mp="15zq1zgc2xf3g">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}